<template lang="html">
  <div class="container-fluid">
    <d-row class="p-2">
      <d-col md="8">
        <form class="main-sidebar__search w-100 d-flex">
          <div class="input-group input-group-seamless">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fas fa-search"></i>
              </div>
            </div>
            <d-form-input
              class="navbar-search"
              type="text"
              placeholder="Procurar por algo..."
              aria-label="Search"
              v-model="pagination.search"
            ></d-form-input>
          </div>
        </form>
      </d-col>
    </d-row>
    <d-row class="row-table">
      <d-col class="col-table">
        <div class="table-overflow">
          <ticket-client-table :tickets="tickets.list" v-if="isCustomer" :show-project="false"/>
          <ticket-table :tickets="tickets.list" v-else/>
        </div>
        <pagination :total-items="tickets.total_items" :pagination.sync="pagination"></pagination>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import TicketTable from '_modules/ticket/components/TicketListTable.vue';
import TicketClientTable from '_modules/ticket/components/TicketClientListTable.vue';
import UploadProjectFile from './UploadProjectFile.vue';

export default {
  name: 'project-tickets',
  components: {
    Pagination,
    TicketTable,
    TicketClientTable,
    UploadProjectFile,
  },
  data() {
    return {
      pagination: {
        search: '',
        project_id: this.$route.params.projectId,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    tickets() {
      const { ticketList } = this.$store.state.ticket;
      if (ticketList && ticketList.list.length) {
        return ticketList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTicketList',
    ]),
    getList() {
      this.getTicketList(this.pagination);
    },
  },
  mounted() {
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>
